import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white py-16 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6">
        {/* Company Information Section */}
        <div className="mb-12 pb-12 border-b border-gray-800">
          <h3 className="text-xl font-bold text-cyan-400 mb-6">運営会社</h3>
          <div className="space-y-3 text-gray-300">
            <p className="text-lg">
              <span className="font-bold text-white">株式会社ジョリーグッド</span>
              <span className="ml-3 text-gray-400">(JOLLYGOOD Inc.)</span>
            </p>
            <p className="flex items-start">
              <i className="ri-map-pin-line text-cyan-400 mr-2 mt-1"></i>
              <span>〒103-0028 東京都中央区日本橋富沢町10−13</span>
            </p>
            <div className="flex flex-wrap gap-6 mt-4">
              <a 
                href="https://jollygood.co.jp/" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer"
              >
                <i className="ri-building-line mr-2"></i>
                会社概要
              </a>
              <a 
                href="https://jollygood.co.jp/privacy_policy/" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer"
              >
                <i className="ri-shield-check-line mr-2"></i>
                プライバシーポリシー
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center text-gray-500">
          <p>&copy; 2025 JOLLYGOOD Inc. All rights reserved.</p>
          <p className="mt-2 text-sm">Powered by Jolly Good</p>
        </div>
      </div>
    </footer>
  );
}
